import React from 'react';
import MermaidDiagram from './MermaidDiagram';
import './diagram.css';

// Renderer dispatch on data.kind (DR-2026-271 renderer seam). 'mermaid' is
// the only kind today; unknown kinds fall back to showing the source.
const DiagramView = ({ data }) => {
  const { kind = 'mermaid', source = '', caption } = data;
  return (
    <figure className="diagram-block">
      {kind === 'mermaid' ? (
        <MermaidDiagram source={source} />
      ) : (
        <pre className="diagram-mermaid-source">{source}</pre>
      )}
      {caption ? <figcaption className="diagram-caption">{caption}</figcaption> : null}
    </figure>
  );
};

export default DiagramView;
